/* TODO:: FIX_SELECT */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// can you remove this @Shajansheriff why do we need this?
import ChevronDown20 from '@carbon/icons-react/es/chevron--down/20';
import Close16 from '@carbon/icons-react/es/close/16';
import Close20 from '@carbon/icons-react/es/close/20';
import { List, Space } from 'antd';
import classNames from 'classnames';
import React, { FC, forwardRef } from 'react';
import ReactSelect, {
  Props,
  components as RsComponents,
  GroupedOptionsType,
  createFilter,
} from 'react-select';
// eslint-disable-next-line import/no-internal-modules
import ReactCreatableSelect, { CreatableProps } from 'react-select/creatable';
// eslint-disable-next-line import/no-internal-modules
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { HeightStyle } from 'components/atoms/input/input';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { Color } from '../../colors';
import { SingleLineEllipsis } from '../../styles';
import { Avatar } from '../avatar';
import { Tag as TagAtom, TagProps } from '../tag';
import { AvatarOption } from './custom-components';
import { SelectMode } from './types';

export const selectPrefix = 'ozone-select';

type UserTagProps = TagProps & {
  imageUrl?: string;
  label?: string;
  companyLogoUrl?: string;
  hoverColor?: string;
};

const Tag = styled(TagAtom)`
  padding: 0 var(--spacing-02) 0 0;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyleAvatar = styled(Avatar)`
  margin-right: var(--spacing-03);
  flex-shrink: 0;
`;

const Ellipsis = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const UserTag: FC<UserTagProps> = ({
  color = 'gray', // not sure if we need this default in code @Shajansheriff
  imageUrl,
  label,
  companyLogoUrl,
  icon,
  ...restProps
}) => (
  <Tag {...restProps} color={color}>
    <Wrapper>
      <StyleAvatar
        size="small"
        companyLogoUrl={companyLogoUrl}
        /**
         * if icon is passed, name and src is unset
         * since avatar component renders icon only when name/ src is unset
         */
        {...(icon ? { icon } : { name: label, src: imageUrl })}
      />
      <Ellipsis title={label}>{label}</Ellipsis>
    </Wrapper>
  </Tag>
);

export const DropdownIndicator = (props) => {
  return (
    <RsComponents.DropdownIndicator {...props}>
      <ChevronDown20 />
    </RsComponents.DropdownIndicator>
  );
};

export const StyledControl = styled(RsComponents.Control)`
  outline: 2px solid !important;
  outline-color: transparent !important;
  outline-offset: -2px;
  border: 0;
  border-bottom: 1px solid var(--gray-50);
  border-radius: 0;
  background-color: var(--gray-10);
  min-height: ${HeightStyle};
  ${ifProp(
    'isFocused',
    css`
      box-shadow: none;
      border-bottom-color: transparent !important;
      outline-color: var(--primary-color) !important;
      outline-offset: -2px;
    `,
  )};
  &:hover {
    background-color: var(--hover-color);
  }
`;

export const Control = (props) => <StyledControl {...props} />;

export const ClearIndicator = (props) => (
  <RsComponents.ClearIndicator {...props}>
    <Close20 />
  </RsComponents.ClearIndicator>
);

const ListItem = styled(List.Item)`
  padding: 0;
`;

const ListItemMeta = styled(List.Item.Meta)`
  align-items: center;

  & .ant-list-item-meta-title {
    margin-bottom: 0;
    color: var(--gray-100);
  }

  & .ant-list-item-meta-description {
    font-size: var(--font-size-sm);
    color: var(--gray-80);
    font-weight: normal;
  }
`;

const Option = (props) => {
  const { data } = props;

  return (
    <RsComponents.Option {...props}>
      <ListItem>
        <ListItemMeta
          avatar={
            <Avatar
              name={data.__isNew__ ? data.value : data.label}
              src={data.imageUrl}
            />
          }
          title={data.label}
          description={data.description}
        />
      </ListItem>
    </RsComponents.Option>
  );
};

const StyledMultiValue = styled(RsComponents.MultiValue)`
  --tag-border-color: var(--tag-surface-color);

  border-radius: 100px;
  margin: var(--spacing-01) 0;
  padding: 0;
  border: 2px solid var(--tag-border-color);
  background: var(--tag-surface-color);
  color: var(--tag-color);
  font-size: var(--font-size-sm);
  line-height: var(--spacing-05);
  display: inline-flex;
  align-items: center;

  &:focus {
    --tag-border-color: var(--blue-60);
  }

  &.disabled,
  &[disabled] {
    --tag-surface-color: var(--gray-10);
    --tag-color: var(--gray-30);
  }

  ${({ color }) => css`
    --tag-surface-color: var(--ozone-${color}-surface);
    --tag-color: var(--ozone-${color});
  `};

  cursor: ${ifProp('onClick', 'pointer', 'initial')};
`;

const SingleValue = ({ data, ...props }) => {
  return (
    <span data-cy="select.field.options">
      <RsComponents.SingleValue {...props}>
        <UserTag
          color={data.color}
          imageUrl={data.imageUrl}
          label={data.__isNew__ ? data.value : data.label}
        />
      </RsComponents.SingleValue>
    </span>
  );
};

const MultiValue = (props) => {
  const { data } = props;

  return <StyledMultiValue color={data?.color || 'gray'} {...props} />;
};

const MultiValueLabel = (props) => {
  const { data } = props;

  return (
    <RsComponents.MultiValueLabel {...props}>
      <Space size="small">
        <Avatar
          size="small"
          src={data.imageUrl}
          name={data.__isNew__ ? data.value : data.label}
        />
        <div>{data.label}</div>
      </Space>
    </RsComponents.MultiValueLabel>
  );
};

const MultiValueRemove = ({ data, ...props }) => {
  const isDisabled = props?.selectProps?.isDisabled;

  return isDisabled ? null : (
    <RsComponents.MultiValueRemove {...props}>
      <Close16 />
    </RsComponents.MultiValueRemove>
  );
};

const StyledTag = styled(TagAtom)`
  ${SingleLineEllipsis};
  display: unset;
`;

const StyledRSOption = styled(RsComponents.Option)`
  display: flex;
  min-width: 0;
`;
const TagOption = (props) => {
  const { data } = props;

  return (
    <StyledRSOption {...props}>
      <StyledTag
        title={data.label}
        color={data.color}
        data-cy={`tag-option-${data.label}`}
      >
        {data.label}
      </StyledTag>
    </StyledRSOption>
  );
};

const TagSingleValue = (props) => {
  const { data } = props;

  return (
    <RsComponents.SingleValue {...props}>
      <TagAtom color={data.color} data-cy={`tag-single-value-${data.label}`}>
        {data.label}
      </TagAtom>
    </RsComponents.SingleValue>
  );
};

interface Option {
  label?: string;
  value?: string | number;
  count?: Color;
  description?: string;
  imageUrl?: string;
}

interface BaseSelectProps {
  type?: SelectMode;
  options?: Option[];
}

interface CustomSelectProps extends Props {
  closeMenuOnSelect?: boolean;
}

type SelectOptions<OptionsType, IsMulti extends boolean> = ReadOnlyArray<
  IsMulti extends true ? GroupedOptionsType<OptionsType> : OptionsType[]
>;

type BaseProps<OptionsType, IsMulti> = {
  type?: SelectMode;
  options?: SelectOptions<OptionsType, IsMulti>;
  value?: ValueType<OptionsType, IsMulti>;
};

export type CreatableSelectProps = BaseSelectProps &
  Omit<CreatableProps<Option, boolean>, 'options'> &
  Omit<CustomSelectProps, 'options'>;

export const CreatableSelect: FC<CreatableSelectProps & ClassNameOnlyProps> = ({
  className,
  components = {},
  ...props
}) => {
  const { type, showMenuOnOpen } = props;

  let customComponents: any = {
    DropdownIndicator: !showMenuOnOpen && (() => null),
    IndicatorSeparator: !showMenuOnOpen && (() => null),
    ClearIndicator,
    Control,
    MultiValueRemove,
  };

  if (type === 'user') {
    customComponents = {
      ...customComponents,
      Option: AvatarOption,
      SingleValue,
      MultiValue,
      MultiValueLabel,
    };
  } else if (type === 'tag') {
    customComponents = {
      ...customComponents,
      Option: TagOption,
      SingleValue: TagSingleValue,
      MultiValue,
    };
  }

  return (
    <ReactCreatableSelect
      className={classNames(`${selectPrefix}-container`, className)}
      classNamePrefix={selectPrefix}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary: 'var(--primary-color)',
        },
      })}
      components={{
        ...customComponents,
        ...components,
      }}
      {...props}
    />
  );
};

export type SelectProps<
  OptionType = OptionTypeBase,
  IsMulti extends boolean = false,
> = BaseProps<OptionType, IsMulti> &
  Omit<CustomSelectProps<OptionType, IsMulti>, 'options' | 'value'>;

export const Select: FC<SelectProps> = forwardRef<any, SelectProps>(
  ({ className, components = {}, ...props }, ref) => {
    const { type = 'basic' } = props;

    let customComponents: any = {
      DropdownIndicator,
      ClearIndicator,
      Control,
      MultiValueRemove,
    };

    if (type === 'user') {
      customComponents = {
        ...customComponents,
        Option: AvatarOption,
        SingleValue,
        MultiValue,
        MultiValueLabel,
      };
    } else if (type === 'tag') {
      customComponents = {
        ...customComponents,
        Option: TagOption,
        SingleValue: TagSingleValue,
        MultiValue,
      };
    }

    /* TODO:: Remove this duplicate and make it into single. Note: I am stupidly sleepy while writing this component. So just POC implementation. */
    return (
      <ReactSelect
        ref={ref}
        className={classNames('ozone-select-container', className)}
        classNamePrefix="ozone-select"
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: 'var(--primary-color)',
          },
        })}
        components={{
          ...customComponents,
          ...components,
        }}
        {...props}
        filterOption={createFilter({
          matchFrom: 'any',
          stringify: (option) => `${option.label}`,
        })}
      />
    );
  },
);

export const UserComponents = {
  Option: AvatarOption,
  SingleValue,
  MultiValue,
  MultiValueLabel,
};

export const TagComponents = {
  Option: TagOption,
  SingleValue: TagSingleValue,
  MultiValue,
};
